import { useMethods } from '@shared/hooks/methods'
import { useDialogs } from '@shared/hooks/dialogs'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import axios from '@shared/utils/axios'
import since from '@shared/utils/since'

export default function ConsultantItem({
    id,
    name,
    disableGutters,
    lastActivity
}) {
    const { showMessage } = useMethods()
    const { showOnly } = useDialogs()

    const handleOpenProfile = async () => {
        showMessage({
            text: 'جارٍ التحميل...',
            loading: true
        })
        try {
            const instance = (await axios.get(`settings/users/${id}/`)).data
            showMessage(null)
            showOnly('user', {instance})
        } catch (e) {
            showMessage({ text: 'حدث خطأ اثناء جلب المستخدم' })
        }
    }

    return (
        <ListItemButton
            disableGutters={disableGutters}
            onClick={handleOpenProfile}
        >
            <ListItemText
                primary={name}
                secondary={since(lastActivity)}
            />
        </ListItemButton>
    )
}